import { commonFilter } from './filter';

export default {
  pageName: 'ByAccount-Download',
  pageId: '20108',
  pagePath: '/opinion/Accounts/ByAccount',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
